import { Fragment } from '@app/modules/fragments/types';
import { webApi } from '@mi-front/api-clients';
import { useMemo } from 'react';
import { mapTranscriptionDtoToBlocks } from '../lib/transcription-mapper';

/**
 * Fetches fragment transcription with Suspense and maps it to v2 blocks.
 */
export function useFragmentTranscription(fragment: Fragment) {
  const { data } = webApi.useGetFragmentDetailTranscriptionSuspense(fragment.id, {});

  const blocks = useMemo(() => {
    if (!data) {
      return [];
    }

    return mapTranscriptionDtoToBlocks(data);
  }, [data]);

  return {
    blocks,
  };
}
